"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDropdownsDefaultValue = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var setDropdownsDefaultValue = exports.setDropdownsDefaultValue = function setDropdownsDefaultValue(sections, change, values) {
  var selectFields = sections.reduce(function (result, section) {
    if (!Array.isArray(section.form)) return result;
    return [].concat(_toConsumableArray(result), _toConsumableArray(section.form.filter(function (field) {
      return ['select', 'country'].includes(field.type);
    })));
  }, []);

  // Set the default value
  selectFields.forEach(function (field) {
    if (!values || !values[field.name]) {
      change(field.name, Array.isArray(field.options) ? field.options[0] : Object.keys(field.options)[0]);
    }
  });
};